import { render } from "./cardPrintedListNew.vue?vue&type=template&id=24bb1382&scoped=true"
import script from "./cardPrintedListNew.vue?vue&type=script&lang=js"
export * from "./cardPrintedListNew.vue?vue&type=script&lang=js"

import "./cardPrintedListNew.vue?vue&type=style&index=0&id=24bb1382&lang=css"
import "./cardPrintedListNew.vue?vue&type=style&index=1&id=24bb1382&scoped=true&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bb1382"]])

export default __exports__